import Vue from 'vue';

export const EventBus = new Vue();

export const Events = {
  Dialog: {
    OpenDialogEvent: 'OpenDialogEvent',
    CloseDialogEvent: 'CloseDialogEvent',
  },
  Contract: {
    ConfirmSettleContractEvent: 'ConfirmSettleContractEvent',
  },
  Request: {
    ConfirmCancelRequestEvent: 'ConfirmCancelRequestEvent',
  },
};
